import { iconSvgMap } from "../Icon/Icon.map";

export const COLORS = [ "primary", "secondary" ] as const;
export type TColor = (typeof COLORS)[number];

export const DESIGNS = [ "default", "underline" ] as const;
export type TDesign = (typeof DESIGNS)[number];

export const iconMap = {
  arrowLeftShort: iconSvgMap.arrowLeftShort,
  arrowRightShort: iconSvgMap.arrowRightShort,
  lock: iconSvgMap.lock,
};

export type TIconName = keyof typeof iconMap;

type TDesignClassStyle = {
  [key in TColor]: string;
};

export interface IDesignClassStyleWithBase extends TDesignClassStyle {
  base: string;
}

type TDesignClassMap = {
  [key in TDesign]: IDesignClassStyleWithBase
};

const baseSharedClasses = "disabled:cursor-not-allowed block min-h-10 flex justify-center items-center text-center font-display opacity-100 lg:hover:opacity-70 transition-opacity duration-300";

export const designClassMap: TDesignClassMap = {
  default: {
    base: `${baseSharedClasses} data-[disabled=true]:!bg-grey-400 data-[disabled=true]:pointer-events-none disabled:bg-grey-400 disabled:text-black p-2.5 rounded-full`,
    primary: "bg-brand text-black",
    secondary: "text-white bg-black",
  },
  underline: {
    base: `${baseSharedClasses} disabled:opacity-30 block underline underline-offset-2 decoration-1`,
    primary: "text-black",
    secondary: "text-white border-white",
  },
};
